import api from "../../services/api";

/**
 * Impressão das notas (BDM-887).
 *
 * O PDF vem da API autenticado, então não dá para apontar um iframe para a
 * URL: baixamos o arquivo com o token e imprimimos a partir de um blob, que
 * é mesma origem — é o que permite disparar o diálogo de impressão direto,
 * sem o usuário abrir a aba e apertar Ctrl+P.
 */
const printBlob = blob => new Promise(resolve => {
    const url = URL.createObjectURL(blob);
    const frame = document.createElement('iframe');

    frame.style.position = 'fixed';
    frame.style.right = '0';
    frame.style.bottom = '0';
    frame.style.width = '0';
    frame.style.height = '0';
    frame.style.border = '0';
    frame.src = url;

    frame.onload = () => {
        try {
            frame.contentWindow.focus();
            frame.contentWindow.print();
        } catch (error) {
            // Navegador que bloqueia impressão de iframe: abrir o PDF numa
            // aba ainda deixa o usuário imprimir por lá.
            window.open(url);
        }

        // O blob e o iframe só podem morrer depois do diálogo; um minuto é
        // folgado para quem está escolhendo a impressora.
        setTimeout(() => {
            document.body.removeChild(frame);
            URL.revokeObjectURL(url);
        }, 60000);

        resolve();
    };

    document.body.appendChild(frame);
});

/** Imprime uma nota. */
export const printDocument = async id => {
    const response = await api.post(`/fiscal-document/print`, { ids: [id] }, { responseType: 'blob' });

    return printBlob(response.data);
};

/** Imprime várias notas num PDF só, na ordem em que foram selecionadas. */
export const printDocuments = async ids => {
    const response = await api.post(`/fiscal-document/print`, { ids }, { responseType: 'blob' });

    return printBlob(response.data);
};

/**
 * Erro de requisição com responseType blob chega como Blob, não como JSON —
 * sem desembrulhar, o usuário veria "[object Blob]" no lugar da mensagem.
 */
export const parseBlobError = async error => {
    const data = error?.response?.data;

    if (!(data instanceof Blob)) {
        return null;
    }

    try {
        const parsed = JSON.parse(await data.text());
        return parsed?.message ?? null;
    } catch (parseError) {
        return null;
    }
};
